import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "programPanel",
    "programRadio",
    "selectedProgramId",
    "selectedClassroomAttendanceType",
  ]

  connect() {
    this.updateSelectedProgram()
  }

  selectProgram(event) {
    const clickedPanel = event.currentTarget
    const radioButton = clickedPanel.querySelector('input[type="radio"]')
    radioButton.checked = true
    this.updateSelectedProgram()
  }

  updateSelectedProgram() {
    this.programPanelTargets.forEach((panel, index) => {
      const radio = this.programRadioTargets[index]
      if (radio.checked) {
        panel.classList.add("Panel--success")
        panel.classList.remove("Panel--subtle", "Panel--borderOnly")
        this.selectedProgramIdTarget.value = panel.dataset.programId
        this.syncClassroomAttendanceType(panel)
      } else {
        panel.classList.remove("Panel--success")
        panel.classList.add("Panel--subtle", "Panel--borderOnly")
      }
    })
  }

  syncClassroomAttendanceType(panel) {
    if (!this.hasSelectedClassroomAttendanceTypeTarget) return
    const attendanceType = panel.dataset.classroomAttendanceType
    if (attendanceType) {
      this.selectedClassroomAttendanceTypeTarget.value = attendanceType
    }
  }
}